// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qcb3","col":"styles_col__3XhKA","actions":"styles_actions__igl_t","conflict":"styles_conflict__3wtaE"};